import { render } from "./AppBuyNft.vue?vue&type=template&id=23883eca&scoped=true"
import script from "./AppBuyNft.vue?vue&type=script&lang=js"
export * from "./AppBuyNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/buyNftModal.scss?vue&type=style&index=0&id=23883eca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23883eca"]])

export default __exports__